import { isNilOrEmpty } from './is-nil-or-empty';

export const isNilOrEmptySafe = (input: () => any): boolean => {
  try {
    const result = input();
    return isNilOrEmpty(result);
  } catch (e) {
    return true;
  }
};
